import { AxiosInstance } from 'axios'
import { RequestError } from '../types/error'
import { Initialize, initializeInternalChat } from '@/types/internalChatAxios'
//import { FavoriteMessage } from '@/types/itemsMessages'
import { useChatStore } from '@/stores/chat'

export interface InternalChatServiceInterface {
  initialize(): Promise<Initialize>;
  sync(): Promise<Initialize>;
}

function InternalChatService (httpClient: AxiosInstance): InternalChatServiceInterface {
  async function initialize (): Promise<Initialize> {
    const chatStore = useChatStore()
    const response = await httpClient.get<initializeInternalChat>('/internal-chat/initialize', chatStore.config)
    let errors: RequestError | null = null
    if (!response.data) {
        const error = JSON.parse(response.request.response)
        if(error.error === 'OperatingHoursInvalidException') {
            window.location.href = `${window.origin}/v2/acesso-expirado`
        }
        errors = {
            status: response.request.status,
            statusText: response.request.statusText,
            message: error.message
        }
    }
    return {
      data: response.data?.data ?? response.data,
      errors
    }
  }
  async function sync (): Promise<Initialize> {
    const chatStore = useChatStore()
    const type = chatStore.getWithService
    const selected = chatStore.getSelected?.id ?? 0
    const response = await httpClient.get<initializeInternalChat>(`/internal-chat/sync/${type}/${selected}`, chatStore.config)
    let errors: RequestError | null = null

    if (!response.data) {
      const error = JSON.parse(response.request.response)
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
        message: error.message
      }
    }
    return {
      data: response.data?.data ?? response.data,
      errors
    }
  }
  return {
    initialize,
    sync
  }
}

export default InternalChatService
